export default __webpack_public_path__ + "static/media/3032.24d90b47.jpg";